import { Icons } from "../../assets/icons";

export interface FooterQuoteCardProps {
  readonly text: React.ReactNode;
  readonly icon: React.ReactNode;
}

// PD-02 Stage pages footer. Branded teal gradient + accent border; the stage
// icon sits inside a soft rounded tile so the big illustration doesn't fight
// with the quote on narrow viewports.
function FooterQuoteCard(props: FooterQuoteCardProps) {
  return (
    <article className="animate__animated animate__fadeInUp mx-auto my-6 flex flex-wrap items-center justify-center gap-6 px-6 py-6 lg:px-32 stage-footer-quote">
      <div className="flex items-center justify-center rounded-xl bg-white/60 p-3 shadow-sm">
        {props.icon}
      </div>
      <div className="flex items-start gap-3 self-center">
        <Icons.QuoteIcon width={64} height={64} />
        <p className="text w-[420px] max-w-full text-justify text-lg leading-relaxed tracking-wide text-slate-800">
          {props.text}
        </p>
      </div>
    </article>
  );
}

export default FooterQuoteCard;
